var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import axios from "axios";
import FingerprintJS from "@fingerprintjs/fingerprintjs";
import { attachConsoleListener, attachListeners, EVENT_LEVELS, getDeviceType } from "./utils";
import { defaultSupportedListeners } from "./utils/Constants";
var http = axios.create({
    headers: {
        "Content-Type": "application/json",
    },
    timeout: 60000,
    withCredentials: false,
});
var EventService = /** @class */ (function () {
    function EventService(config) {
        var _a, _b, _c, _d, _e, _f, _g;
        this.timeoutId = null;
        this.prevFiredEventTime = 0;
        this._hubQueue = [];
        this.startEvents = false;
        this.heartBeatStartTime = 0; // start time from where the event has started
        this.fpDone = false;
        this.tenant = (_a = config.eventSettings) === null || _a === void 0 ? void 0 : _a.tenant;
        this.requestId = (_b = config === null || config === void 0 ? void 0 : config.eventSettings) === null || _b === void 0 ? void 0 : _b.requestId;
        this.discriminator = (_c = config === null || config === void 0 ? void 0 : config.eventSettings) === null || _c === void 0 ? void 0 : _c.discriminator;
        this.lastKnownStatus = (_d = config === null || config === void 0 ? void 0 : config.eventSettings) === null || _d === void 0 ? void 0 : _d.lastKnownStatus;
        this.TIMEOUT_DURATION = ((_e = config === null || config === void 0 ? void 0 : config.extraConfig) === null || _e === void 0 ? void 0 : _e.heartBeatTimeoutDuration) || 10000;
        this.STOP_DURATION = ((_f = config === null || config === void 0 ? void 0 : config.extraConfig) === null || _f === void 0 ? void 0 : _f.heartBeatStopDuration) || 1000 * 2 * 60; // 2mins;
        this.appId = config === null || config === void 0 ? void 0 : config.extraConfig.appId;
        this.hubConfig = config.hubConfig;
        var _h = attachListeners(((_g = config === null || config === void 0 ? void 0 : config.listenerConfig) === null || _g === void 0 ? void 0 : _g.supportedListeners) || defaultSupportedListeners), listeners = _h.listeners, app = _h.app;
        this.listeners = listeners;
        this.app = app;
        this.device = getDeviceType();
        attachConsoleListener(this.listeners);
    }
    /*
     fireInternal - Fires an internal event.
  
     @param type (string) - The type of the event to fire.
     @param payload (Record<string, any>) - Data associated with the event.
     @param config (optional) - Configuration options:
     - eventLevel (EVENT_LEVELS) - Specifies the event level.
     - deliverToHub (boolean) - Whether the event should be sent to the hub.
     */
    EventService.prototype.fireInternal = function (type, payload, config) {
        this.fire(type, __assign(__assign({}, payload), { internal: true }), { internal: true }, config);
    };
    /*
     fire - Fires an event with payload, labels, and configuration options.
  
     @param type (string) - The type of the event to fire.
     @param payload (Record<string, any>) - Data associated with the event.
     @param labels (optional) - Additional labels or metadata for the event.
     @param config (optional) - Configuration options:
     - eventLevel (EVENT_LEVELS) - Specifies the event level.
     - listeners (PLATFORM[]) - Platforms to deliver the event to.
     - deliverToHub (boolean) - Whether the event should be sent to the hub.
     */
    EventService.prototype.fire = function (type, payload, labels, config) {
        var _a;
        try {
            var internal = (labels === null || labels === void 0 ? void 0 : labels.internal) ? labels.internal : false;
            if (!internal) {
                this.listeners.forEach(function (l) { return l(type, payload, config === null || config === void 0 ? void 0 : config.eventLevel, config === null || config === void 0 ? void 0 : config.listeners); });
            }
        }
        catch (e) {
            console.warn("[events] observed an error while eventing to listeners", e);
        }
        finally {
            // finally, deliver to events hub
            if ((_a = config === null || config === void 0 ? void 0 : config.deliverToHub) !== null && _a !== void 0 ? _a : true) {
                this.processHubEvent(type, payload, config === null || config === void 0 ? void 0 : config.eventLevel);
            }
        }
    };
    EventService.prototype.canFireHeartbeatEvents = function () {
        this.startEvents = true;
        this.heartBeatStartTime = Date.now();
        this.updateLastEventTime();
        console.log("can fire heatbeat events");
    };
    EventService.prototype.clearTimedEvents = function () {
        this.startEvents = false;
        if (this.timeoutId) {
            clearTimeout(this.timeoutId);
            this.timeoutId = null;
        }
        this.heartBeatStartTime = 0;
        console.log("Event heartbeats have stopped");
    };
    EventService.prototype.loadFpAndFire = function (requestId, discriminator) {
        return __awaiter(this, void 0, void 0, function () {
            var fp, _a, visitorId, components, confidence, version;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, FingerprintJS.load()];
                    case 1:
                        fp = _b.sent();
                        return [4 /*yield*/, fp.get()];
                    case 2:
                        _a = _b.sent(), visitorId = _a.visitorId, components = _a.components, confidence = _a.confidence, version = _a.version;
                        this.fireInternal("FP", {
                            requestId: requestId,
                            timestamp: new Date().toISOString(),
                            discriminator: discriminator,
                            visitorId: visitorId,
                            components: components,
                            score: confidence.score,
                            version: version,
                        }, { eventLevel: EVENT_LEVELS.DEBUG });
                        this.fpDone = true;
                        return [2 /*return*/];
                }
            });
        });
    };
    EventService.prototype._prepHubData = function (tenant, type, payload) {
        var requestId = payload.requestId, timestamp = payload.timestamp, internal = payload.internal, otherPayload = __rest(payload, ["requestId", "timestamp", "internal"]);
        var device = this.device;
        var app = this.app;
        var appConfig = this.appId ? { appId: this.appId } : null;
        var internalObj = internal ? { internal: true } : {};
        return __assign(__assign({ tenantId: tenant, workspaceId: tenant, requestId: requestId, event: type, eventTime: timestamp }, internalObj), { payload: __assign(__assign(__assign({}, appConfig), otherPayload), { device: device, app: app }) });
    };
    EventService.prototype._deliverToHub = function (data, eventLevel) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, deliverToHub, eventLevels;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.hubConfig, deliverToHub = _a.deliverToHub, eventLevels = _a.eventLevels;
                        if (!(deliverToHub !== null && deliverToHub !== void 0 ? deliverToHub : true)) { // By default deliver the events to hub
                            return [2 /*return*/, Promise.resolve()];
                        }
                        if (!((eventLevels && eventLevels.length > 0 && eventLevel) ? eventLevels.includes(eventLevel) : true)) return [3 /*break*/, 2];
                        return [4 /*yield*/, http.post(this.hubConfig.hubUrl, data)
                                .then(function (response) {
                                var status = response.status;
                                if (status === 200) {
                                    // Success, yay!
                                    console.log("[events-hub] ".concat(data.event, " \u2014 ").concat(response.data.id, " delivered"));
                                    _this.updateLastEventTime(); // checking whether an event was delivered in the last 10 seconds;
                                }
                                else {
                                    console.error("[events-hub] ".concat(data.event, " delivery failed (status: ").concat(status, ")"));
                                }
                            })
                                .catch(function (e) {
                                console.error("[events-hub] ".concat(data.event, " delivery failed (message: ").concat((e === null || e === void 0 ? void 0 : e.message) ? e.message : "na", ")"));
                            })
                                .finally(function () {
                                // do something here?
                            })];
                    case 1:
                        _b.sent();
                        _b.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    EventService.prototype.processHubEvent = function (type, payload, eventLevel) {
        // 1. check if tenant is resolved yet, if yes then start clearing the hubQueue
        if (!this.tenant) {
            this._hubQueue.push({ type: type, payload: payload, eventLevel: eventLevel });
            return;
        }
        if (!this.fpDone) {
            this.fpDone = true;
            this.loadFpAndFire(payload.requestId, payload === null || payload === void 0 ? void 0 : payload.discriminator);
        }
        // Now that tenant value is available, clear any pending items
        if (this._hubQueue.length > 0) {
            while (this._hubQueue.length !== 0) {
                // loop on pending items to deliver to hub
                var e = this._hubQueue.splice(0, 1);
                if (e.length > 0) {
                    this._deliverToHub(this._prepHubData(this.tenant, e[0].type, e[0].payload), e[0].eventLevel);
                }
            }
        }
        // deliver to hub directly
        this._deliverToHub(this._prepHubData(this.tenant, type, payload), eventLevel);
    };
    EventService.prototype.updateLastEventTime = function () {
        var _this = this;
        this.prevFiredEventTime = Date.now();
        if (this.timeoutId) {
            clearTimeout(this.timeoutId);
        }
        if (this.startEvents) {
            this.timeoutId = setTimeout(function () { return _this.checkAndFireDummyEvent(); }, this.TIMEOUT_DURATION);
        }
    };
    EventService.prototype.checkAndFireDummyEvent = function () {
        var _this = this;
        if (!this.startEvents)
            return;
        if (!this.monitorHeartBeatEvents()) {
            this.clearTimedEvents();
            return;
        }
        var currentTime = Date.now();
        console.log("currentTime - prevFiredEventTime", currentTime - this.prevFiredEventTime);
        if (currentTime - this.prevFiredEventTime >= this.TIMEOUT_DURATION) {
            console.log("No events fired in the last 10 seconds. Firing heartbeat event.");
            this.fire("HEARTBEAT", {
                timestamp: new Date().toISOString(),
                requestId: this.requestId,
                discriminator: this.discriminator,
                lastStatus: this.lastKnownStatus,
            }, { internal: true });
        }
        else if (this.startEvents || this.monitorHeartBeatEvents()) {
            this.timeoutId = setTimeout(function () { return _this.checkAndFireDummyEvent(); }, this.TIMEOUT_DURATION);
        }
    };
    EventService.prototype.monitorHeartBeatEvents = function () {
        return (Date.now() - this.heartBeatStartTime) < this.STOP_DURATION;
    };
    return EventService;
}());
export { EventService };
//# sourceMappingURL=EventService.js.map